<div class="reset-pswd-component">
  <div class="outside-login-box pull-right">
    <a (mouseenter)="dropdownmenu.classList.add('showThin')" (mouseleave)="dropdownmenu.classList.remove('showThin')"
       class="mat-list-item">
      <span class="btn-style">
        {{translate.instant('TOOLBAR.LANGUAGE')}} <i _ngcontent-hvq-21="" class="material-icons ic-arrow-drop-down">arrow_drop_down</i>
      </span>
      <div #dropdownmenu class="dropdownmenu">
        <ul>
          <li>
            <nestas-lang></nestas-lang>
          </li>
        </ul>
      </div>
    </a>
  </div>

  <mat-card *ngIf="success" align="center">
    <div class="mat-card-wrapper">
      <div mat-card-image>
        <i class="material-icons green">check_circle</i>
      </div>
      <mat-card-title>{{translate.instant('MESSAGE.PASSWORD_RESETED')}}</mat-card-title>
      <br/>
      <a (click)="cancel()" class="link">{{translate.instant('BUTTON.ACTION.LOGIN')}}</a>
      <br/>
    </div>
  </mat-card>

  <mat-card *ngIf="!success" align="center" class="login-box">
    <img alt="Nestas Logo" src="../../assets/NestasLogoHeader.png" width="80" height=""/>
    <br/><br/><br/>
    <mat-card-title>{{translate.instant('RESET_PASSWORD.TITLE')}}</mat-card-title>
    <br/>
    <mat-form-field>
      <input matInput type="password" [placeholder]="translate.instant('DATA.PASSWORD')" [(ngModel)]="password"
             class="password-input">
      <mat-hint class="red" *ngIf="password != confirmPassword.value" align="end" color="warn">
        {{translate.instant('MESSAGE.NOT_MATCH', {data: translate.instant('DATA.PASSWORD')})}}
      </mat-hint>
    </mat-form-field>

    <mat-form-field>
      <input matInput #confirmPassword type="password" [placeholder]="translate.instant('DATA.CONFIRM_PASSWORD')"
             class="password-input">
      <mat-hint class="red" *ngIf="password != confirmPassword.value" align="end" color="warn">
        {{translate.instant('MESSAGE.NOT_MATCH', {data: translate.instant('DATA.PASSWORD')})}}
      </mat-hint>
    </mat-form-field>
    <br/><br/>
    <div class="alert-info" *ngIf="!passwordSecured()" align="left">
      <i class="material-icons ic-info">info</i>
      {{translate.instant('MESSAGE.ERROR.UNSECURE_PASSWORD')}}
    </div>
    <br/>
    <button mat-raised-button color="primary" class="confirm-btn"
            [disabled]="!password || password != confirmPassword.value" (click)="resetPassword()">
      {{translate.instant('BUTTON.ACTION.RESET_PASSWORD')}}
    </button>
    <br/><br/>
    <a (click)="cancel()" mat-stroked-button class="link">{{translate.instant('BUTTON.ACTION.CANCEL')}}</a>
  </mat-card>
</div>
